import { useMemo } from "react";
import { useWatch } from "react-hook-form";

import { useGetScheduleOptions } from "api/queries/location/useGetScheduleOptions";
import { ScheduleOptionsConfig } from "@RequestFormV2/sections/Schedule/utils/scheduleOptions";

export function useScheduleData() {
  const location = useWatch({ name: "organizational.location" });

  const { data: scheduleOptionsData, isLoading: isLoadingScheduleOptions } = useGetScheduleOptions(location ?? "", {
    enabled: !!location,
  });

  const scheduleOptions: ScheduleOptionsConfig | undefined = scheduleOptionsData?.schedule_options;

  return useMemo(
    () => ({
      location,
      scheduleOptions,
      isLoadingScheduleOptions,
    }),
    [location, scheduleOptions, isLoadingScheduleOptions],
  );
}
